import styled from "styled-components";

export const Container = styled.div`
    position: absolute;
    left: ${props => (props.$isVisible ? "350px" : "10px")};
    top: 0px;
    transition: left 0.3s ease-in-out;

    /* Resolution Select Styles */
    .resolution-select .ant-select-selector {
        border-radius: 12px !important;
        height: 44px !important;
        padding: 0 12px !important;
        border-color: #e8e8e8 !important;
    }

    .resolution-select .ant-select-arrow {
        right: 12px !important;
    }

    .resolution-select .ant-select-selection-item {
        line-height: 42px !important;
    }

    .resolution-select:hover .ant-select-selector {
        border-color: #40a9ff !important;
    }

    .resolution-select .ant-select-dropdown {
        padding: 4px !important;
        border-radius: 12px !important;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
        max-height: 400px !important;
        overflow-y: auto !important;
    }

    .resolution-select .ant-select-item {
        padding: 0 !important;
    }

    .resolution-select .ant-select-item-option-active > div {
        background: #f5f5f5 !important;
    }

    .resolution-select .ant-select-item-option-selected > div {
        background: #e6f7ff !important;
    }

    /* Scrollbar Styles */
    ::-webkit-scrollbar {
        width: 6px;
    }

    ::-webkit-scrollbar-track {
        background: #f5f5f5;
        border-radius: 3px;
    }

    ::-webkit-scrollbar-thumb {
        background: #d9d9d9;
        border-radius: 3px;
    }

    ::-webkit-scrollbar-thumb:hover {
        background: #bfbfbf;
    }
`;

export const FlexColumn = styled.div`
    display: flex;
    flex-direction: column;
`;

export const HexagonHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 16px;
`;

export const HexagonTitle = styled.h4`
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: #111;
`;

export const HexagonCount = styled.div`
    background: #f0f7ff;
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 13px;
    color: #1890ff;
    font-weight: 500;
`;

export const IconText = styled.span`
    color: #111;
    font-size: 14px;
    font-weight: 500;
    white-space: nowrap;
`;

export const OtherHexagonsContainer = styled.div`
    margin-top: 16px;
    padding: 12px;
    background-color: #f9f9f9;
    border-radius: 8px;
`;

export const OtherHexagonsHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
`;

export const ColorLabelContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const ColorSquare = styled.div`
    width: 16px;
    height: 16px;
    background-color: ${props => props.color};
    border-radius: 4px;
    border: 1px solid #d9d9d9;
`;

export const LabelText = styled.div`
    font-weight: 500;
    font-size: 14px;
`;
